export default __webpack_public_path__ + "static/media/21-cards-trick-mockup.790ef385.png";